let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ddsXx")).then(() => parcelRequire('90eyR'));